import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  teamsExecutiveDirectorCountById,
  teamsFibcCountById,
  teamsFiblCountById,
  teamsSeniorCoachCountById,
} from '/redux/selector/coach.selector';

import Stats from './Stats';

export default connect(
  createStructuredSelector({
    seniorCoachCount: teamsSeniorCoachCountById,
    executiveDirectorCount: teamsExecutiveDirectorCountById,
    fibcCount: teamsFibcCountById,
    fiblCount: teamsFiblCountById,
  }),
)(Stats);
